import { CurrencyAmount, Message } from '~/components/component-library'
import { getIdleUsdcValue } from '~/components/smart-accounts/SmartAccountsList/getIdleUsdcValue'
import { useActiveOrgMember } from '~/hooks/org'
import { useOrgBalances } from '~/hooks/useBalances'
import { useWorkspaceAutoEarn } from '~/hooks/useWorkspaceAutoEarn'
import { OrgSmartAccount } from '~/types'

const IDLE_USDC_BANNER_THRESHOLD_USD = 100

// Owners turn auto-earn on from here, for whichever networks qualify. Anyone
// can open a transaction that is awaiting approval.
export const IdleUsdcMessage = ({
  accounts,
  balances,
  treasuryAddress,
}: {
  accounts: OrgSmartAccount[]
  balances: ReturnType<typeof useOrgBalances>['balances']
  treasuryAddress: string
}) => {
  const orgMember = useActiveOrgMember()
  const { data, toggle, isPending } = useWorkspaceAutoEarn()

  if (!data) return null
  const amount = getIdleUsdcValue({
    accounts,
    balances,
    eligibleChainIds: data.eligibleChainIds,
    thresholdUsd: IDLE_USDC_BANNER_THRESHOLD_USD,
  })
  if (amount === undefined) return null

  const getAction = () => {
    // Checked first: the server refuses a second transaction while one is pending
    if (data.pendingTransactionId)
      return {
        label: 'Review transaction',
        href: {
          path: `/accounts/${treasuryAddress}/transactions/${data.pendingTransactionId}/`,
        },
      }
    if (orgMember?.role !== 'OWNER') return undefined
    return {
      label: 'Turn on auto-earn',
      isLoading: isPending,
      onClick: () => toggle(true),
    }
  }

  return (
    <Message variant="info" action={getAction()}>
      <span>
        <span className="font-medium">
          <CurrencyAmount layout="inline" value={amount} /> USDC
        </span>{' '}
        is not earning interest
      </span>
    </Message>
  )
}
